<template>
  <nav class="subnav">
    <router-link to="/creators/create" class="btn btn-secondary btn-sm">Add creator</router-link>
  </nav>
</template>

<script>
export default {};
</script>

<style>
</style>